import React, { useState } from "react";
import { Alert } from "react-bootstrap";

const CookieWarning = () => {
  const [showWarning, setShowWarning] = useState(true);

  const handleDismiss = () => {
    setShowWarning(false);
    localStorage.setItem('cookiePolicyAccepted', "true");
    // You can also set a cookie here to remember that the user has dismissed the warning
  };

  return (
    <Alert
      show={showWarning}
      variant="warning"
      onClose={handleDismiss}
      dismissible
    >
      This site uses cookies to enhance your browsing experience. By continuing
      to use this site, you consent to our use of cookies.
    </Alert>
  );
};

export default CookieWarning;
